
import Vue from "vue";
import { Prop, Watch, Component } from "vue-property-decorator";

@Component
export default class ZipServe extends Vue {
  newZip: string = "";
  zips: Array<string> = [];

  @Prop({ default: "" })
  zipCodes: string;

  @Watch("newZip")
  newZipChanged(val) {
    if (val.length > 2) {
      if (this.zips.indexOf(val) === -1) {
        this.zips.push(val);
        this.$emit("updateZips", this.zips.join(", "));
      }
      this.newZip = null;
    }
  }

  created() {
    this.zips = this.zipCodes.split(", ");
    if (this.zips[0] === "") {
      this.zips.splice(0, 1); // remove the first empty string
    }
  }

  deleteZip(idx) {
    this.zips.splice(idx, 1);
    this.$emit("updateZips", this.zips.join(", "));
  }
}
